<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <el-button type="primary"
                 :disabled="pagination.total === 0"
                 @click="dialogVisible=true">批量转发简历
      </el-button>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="user_id"
                         label="零工ID"></el-table-column>
        <el-table-column prop="name"
                         label="姓名"></el-table-column>
        <el-table-column prop="address"
                         label="所在地"></el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">未查看</span>
            <span v-if="scope.row.status === 1">已查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="投递时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作">
          <template slot-scope="scope">
            <router-link
              :to="{path: '/resume/audit-detail',query:{id:scope.row.resume_id,position_id: search.position_id}}">
              <el-button type="text"
                         size="mini">查看
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog :visible.sync="dialogVisible"
               width="30%">
      <span>确认将勾选简历转发至招聘方邮箱吗?</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onForwardResume()">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import table from '@/mixins/table-v1'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      dialogVisible: false,
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      // searchRules,
      search: {
        position_id: this.$route.query.id,
        resume_ids: [],
      },
      // 搜索字段申明
      searchFieldType: {
        position_id: Number,
      },

    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['getResumeTable', 'exportResume', 'sendResumes',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getResumeTable', params)
    },
    onForwardResume () {
      if (this.search.resume_ids.length <= 0) {
        this.$message.error('请至少批量转发一份简历')
        this.dialogVisible = false
        return false
      }

      return request.common('sendResumes', this.search).then((res) => {
        this.search.resume_ids = []
        this.$message({
          showClose: true,
          message: '批量转发简历成功',
          type: 'success',
        })
        this.dialogVisible = false
        this.onSearch()
      })
    },
    handleSelectionChange (val, index) {
      this.search.resume_ids = val.map(item => item.resume_id)
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/resume/pages/ResumeAuditTable.vue